import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';
import * as types from './types';

const INITIAL_STATE = {
    esperandoSolicitacao: false,
    error: false,
    error_elo: false,
    mensagem: ''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case types.CERTIFICADO_DEFICIENCIA_IMPRESSAO_SOLICITADA:
            return { ...state, esperandoSolicitacao: true, error: false, error_elo: false, mensagem: '' };

        case types.CERTIFICADO_DEFICIENCIA_IMPRESSAO_RECEBIDA:
            return { ...state, esperandoSolicitacao: false, mensagem: 'sucesso' };

        case types.CERTIFICADO_DEFICIENCIA_ERRO_ELO:
            return { ...state, esperandoSolicitacao: false, error_elo: true }
            
        case types.CERTIFICADO_DEFICIENCIA_ERRO_IMPRESSAO_RECEBIDO:
            return { ...state, esperandoSolicitacao: false, mensagem: (action.payload) ? action.payload : MSG_ERRO_SERVIDOR, error: true };

        case types.CERTIFICADO_DEFICIENCIA_LIMPAR_MENSAGEM:
            return { ...state, error: false, mensagem: '' };

        case types.CERTIFICADO_DEFICIENCIA_NAO_ENCONTRADA:
            return {...state, esperandoSolicitacao: false, mensagem: 'not_found', error_elo: false}

        default:
            return state;
    }
}
